<template>
  <div>
    <el-card class="box-card">
      <el-form :inline="true">
        <SearchGrid>
          <el-form-item label="市场名称">
            <el-select v-model="marketId" clearable style='width: 200px;' placeholder="请选择">
              <el-option v-for="(item, index) in $key.common.market" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提现申请单号">
            <el-input placeholder="请选择" clearable v-model="applyCode"></el-input>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="auditStatus" clearable style='width: 200px;' placeholder="请选择">
              <el-option v-for="(item, index) in $key.myAccount.auditStatus" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请日期">
            <el-date-picker
              clearable
              v-model="startApplyTime"
              type="date"
              placeholder="开始日期">
            </el-date-picker>
            -
            <el-date-picker
              clearable
              v-model="endApplyTime"
              type="date"
              placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch"><i class="fa fa-search"> 查询</i>
            </el-button>
            <el-button type="primary" plain @click="handleReset"><i class="fa fa-refresh"> 重置</i>
            </el-button>
          </el-form-item>
        </SearchGrid>
      </el-form>
    </el-card>
    <!-- 导出 -->
    <inquery-result style="margin-bottom: 20px;" :isExport='false'></inquery-result>
    <el-table ref="zTable" :data="tableData">
      <el-table-column prop="marketName" label="市场名称" align="center"></el-table-column>
      <el-table-column prop="applyCode" label="提现申请单号" align="center" width="140"></el-table-column>
      <el-table-column prop="exAccountNo" label="提现账号" align="center" width="200"></el-table-column>
      <el-table-column prop="bankCardNum" label="到账账号" align="center"></el-table-column>
      <el-table-column prop="applyAmount" label="金额（元）" align="center" width="180"></el-table-column>
      <el-table-column prop="applyTime" label="申请时间" align="center"></el-table-column>
      <el-table-column prop="" label="状态" align="center" :formatter="auditStatusCode"></el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="scope">
          <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout='total, prev, pager, next'
      :current-page.sync="currentPage"
      :total='total'
      @current-change="changePage"
      background>
    </el-pagination>
    <withdrawal-detail v-if="showDetail" :detailData="detailData" @done="handleClose"></withdrawal-detail>
  </div>
</template>

<script>
import api from '@/api'
import { formatTime } from '@/utils/util'
import withdrawalDetail from './withdrawal-detail'
export default {
  components: {
    withdrawalDetail
  },
  data () {
    return {
      // 市场
      marketId: '',
      // 状态
      auditStatus: '',
      // 提现申请单号
      applyCode: '',
      // 提现日期
      startApplyTime: '',
      endApplyTime: '',
      // 详情页
      showDetail: false,
      // 列表信息
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 10
    }
  },

  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 查询
    handleSearch () {
      this.fetchList(1)
    },
    // 重置
    handleReset () {
      this.auditStatus = ''
      this.startApplyTime = ''
      this.endApplyTime = ''
      this.applyCode = ''
      this.marketId = ''
      this.fetchList(1)
    },
    // 获取列表数据
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        marketId: this.marketId,
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        auditStatus: this.auditStatus,
        applyCode: this.applyCode,
        startApplyTime: formatTime(this, this.startApplyTime),
        endApplyTime: formatTime(this, this.endApplyTime, 1),
      }

      let res = await api.myAccount.withdrawList(param)
      this.tableData = res.data.rows
      this.total = res.data.totalElements
    },
    // 详情
    async toDetail (row) {
      let param = {
        id: row.id
      }
      this.detailData = (await api.myAccount.getWithdrawRecordsDetail(param)).data
      this.showDetail = true
      console.log(this.showDetail)
    },
    // 交易状态
    auditStatusCode (row) {
      if (row.auditStatus === '10') {
        return '待审核'
      } else if (row.auditStatus === '20') {
        return '审核通过'
      } else if (row.auditStatus === '30') {
        return '审核驳回'
      } else {
        return '/'
      }
    },
    // 关闭弹窗
    handleClose () {
      this.showDetail = false
    },
    // 分页
    changePage (page) {
      this.fetchList(page)
    },
  }
}
</script>

<style lang="scss" scoped>
  .pagination {
    margin: 20px 0 20px 0;
    float: right;
  }
  ::v-deep .table-page-search-submitButtons{
    margin-left: 100px
  }
</style>
